export default __webpack_public_path__ + "3a1ee0359e6eff0f03bf634f6dbb3f91.svg";